/**
 * Audit API client (bd deepcontext-ikzz.5).
 *   GET /api/admin/audit          — paginated feed (strict admin)
 *   GET /api/admin/audit/filters  — distinct actors / companies / blueprints
 */
import {api} from '../contexts/AuthContext';

export type AuditActorType = 'user' | 'ai_rewrite' | 'system';
export type AuditEntityType =
    | 'blueprint' | 'site_list' | 'scheduled_job' | 'user' | 'company' | 'brief' | 'equativ_taxonomy' | 'setting';
export type AuditAction = 'created' | 'edited' | 'deleted';

export interface AuditEntry {
    id: string;
    createdAt: string;
    actorType: AuditActorType;
    actorUserId: string | null;
    actorName: string | null;
    actorEmail: string | null;
    actorRole: string | null;
    entityType: AuditEntityType;
    entityId: string;
    entityName: string | null;
    companyId: string | null;
    companyName: string | null;
    action: AuditAction;
    changes: Record<string, {before: unknown; after: unknown}> | null;
    reason: string | null;
}

export interface AuditQuery {
    entityType?: string;
    entityId?: string;
    actorUserId?: string;
    companyId?: string;
    from?: string;
    search?: string;
    page: number;
    limit: number;
}

export interface AuditFilters {
    actors: Array<{id: string; name: string | null; email: string | null}>;
    companies: Array<{id: string; name: string | null}>;
    blueprints: Array<{id: string; name: string | null}>;
}

export async function fetchAudit(params: AuditQuery): Promise<{items: AuditEntry[]; total: number}> {
    const res = await api.get('/api/admin/audit', {params});
    return {items: res.data.items, total: res.data.total};
}

export async function fetchAuditFilters(): Promise<AuditFilters> {
    const res = await api.get('/api/admin/audit/filters');
    return res.data;
}
